export class CommonService {
  static REDIS_INTERFACE_AVAILABLE_INVENTORY_ROOM_PREFIX = 'REDIS_INTERFACE_ROOM_';
  static REDIS_AVAILABLE_INVENTORY_KEY_PREFIX = 'AI:';

  static createAvailableInventoryKey(key: string): string {
    return CommonService.REDIS_INTERFACE_AVAILABLE_INVENTORY_ROOM_PREFIX + key;
  }
}
